export class HtmlUtil {
    private static preScrollYVal: any;
    private static isScrollBarBeingHidden = false;
   /**
    * calculate the table height for showing rows up to the max row count and if the table contains more rows that the max row cnt.
    * if the maxRowCnt == -1, calculate the height for all the rows
    * note: table head may have tr rows such as  '<thead><tr><th>....</th></tr></thead>'
    *       or table head may have no tr rows such as  as '<thead><th>...</th></thead>'
    */
   static calculateTableDisplayHeight(table: HTMLTableElement, maxRowCnt: number): number {
      // get all table row height (tr rows)
      const trRowsInTheTable: number = table.rows.length;
      const trRowsInTheHead: number = table.tHead.rows.length;
      const trRowsForDisplay: number  = (maxRowCnt !== -1 && ((maxRowCnt + trRowsInTheHead) < trRowsInTheTable) ) ?
                                               (maxRowCnt + trRowsInTheHead) : trRowsInTheTable;
      let heightForTable = 0;
      const startIdx: number = trRowsInTheHead;
      for (let i = startIdx; i < trRowsForDisplay;  i++) {  // row[0] may be under <thead>
          heightForTable += table.rows[i].offsetHeight;
      }

      // add the table head row height <thead row)
      heightForTable += table.tHead.offsetHeight;
      return heightForTable;
    }

    /**
     * this method is going to handle the popover being flicking when it is too long causing scrollbar visible:
     * when mouse entering, set the window scroll-y style as hidden if no scrollnar visible upon moouse enter
     * when mouse leaving, set the window scroll-y style back if it was hidden upon mouse upon mouse enter.
     * @param type string  onShow - popover show upon mouse enter, onHide - popover hide upon mouse leave
     */
    static popOverHandler(type: string) {
      const hasVScroll: boolean = document.documentElement.scrollHeight !== document.documentElement.clientHeight;
      if (type === 'onShow') {
        if (!hasVScroll) {
           document.documentElement.style.overflowY = 'hidden'; // not not flickiering on mouse over
        }
      }
      if (type === 'onHide') {
        document.documentElement.style.overflowY = 'auto';  // for scrollbar not randomly disappear on mouse off
      }
    }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/shared/html-util.ts